import React from 'react'

import { useParams } from 'react-router-dom'
import WrapperTextPage from '../../../modules/WrapperTextPage/WrapperTextPage'

const DynamicTrophyBook = () => {
  const { id = '49' } = useParams()

  return <WrapperTextPage id={id} />
}

export default DynamicTrophyBook
